<file-manager [initialPath]="hrInitialPath" [featureKey]="'HR_FILE_MANAGER'"></file-manager>
